export const ADD_USER = "Add User";
export const CREATE_USER = "Create User";
export const CLOSE = "Close";
export const MANAGE_USERS = "Manage Users";
export const MANAGE_PARENT_CHILD_DUNS = "Manage Parent Child Duns";
export const MSG_MANAGE_USERS_SELECT_VENDOR =
  "Please select Vendor to add user details.";
export const MSG_MANAGE_USERS_CREATE_USER_SUCCESS =
  "User creation request is In-process.";
export const NO_DATA = "No data to show..";
export const BASIC_DETAILS = "Basic Details";
export const ADDRESS_DETAILS = "Address Details";
export const VSP_DETAILS = "VSP Details";
export const MSG_ERROR_VALIDATE_EMAIL = "API Error while validating email.";
export const MSG_ERROR_EMAIL_ALREADY_EXISTS = "Email already registered.";
export const MSG_MANAGE_USERS_CREATE_USER_FAIL =
  "Unable to create User, Please try again.";
export const MSG_PARENT_CHILD_CANT_BE_SAME = "Parent and Child can't be same.";
export const MSG_NOT_AUTHORIZED_TO_ACCESS =
  "You are not authorized user to access ";
export const RESTRICT_INTERNAL_USER_EMAIL =
  "Email should not be ending with either @macys.com or @bloomingdales.com.";

export const BTN_CONFIRM_PUBLISH = "Confirm & Publish";
export const BTN_SUBMIT = "SUBMIT";

export const OPT_PARENT = "parent";
export const OPT_CHILD = "child";
export const OPT_RELATIONTYPE = "relationshiptype";
export const LBL_DUNS_DP = "Search by Duns/Company name..";
export const LBL_PARENT_COMP = "Parent Company/ Seller Name";
export const LBL_CHIELD_COMP = "Child Company/ Seller Name";
export const LABEL_CONFIRM_DUNS_RELATION = "Confirm Parent/Child relation";
export const LBL_VENDOR_RELATION = "Vendor Relationship";
export const LBL_VENDOR_RELATION_TT = "Parent/Child Seller Relationship";
export const LBL_VENDOR_RELATION_PH = "Select Relationship";

//Default values for fields
export const DEFAULT_LOCALE = "English";
export const DEFAULT_VMS_ROLE = "externalVendorGeneric";
export const YES = "YES";
export const NO = "NO";
export const PARENT_CHILD_CONFIRMATION_MSG =
  "Are you sure you want to create parent/child relation between vendor:";
export const PARENT_CHILD_CONFIRMATION_MSG_PARENT = "as parent to vendor:";
export const PARENT_CHILD_CONFIRMATION_MSG_CHILD = "as child.";
export const VENDOR_RELATIONSHIP_OPTIONS_KEY = "vendor_relationship_type";
export const MSG_ERROR_PARENT_CHILD_FAIL =
  "Unable to create Parent/Child relation, Please try after sometime.";
